// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"05a819d4","818":"b0d1d928"}[chunkId] + ".css";
};